import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation ApplyTaxProfileTemplate($input: TaxProfileTemplateApplyInput!) {
    applyTaxProfileTemplate(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxProfile {
        id
        productId
        sourceTaxProfileTemplateId
        sourceTemplateVersionId
        state
      }
    }
  }
  ${ErrorMessageInfo}
`;
